import axios from 'axios'
import { Configurations } from 'config/config'

/**
 * Asynchronous function to fetch user permissions data.
 *
 * @param {string} userName - The email/username of the user.
 * @returns {Promise<*>} A promise that resolves to the API response or null in case of an error.
 */
export const fetchUserPermissions = async (userName) => {
    try {
        const response = await axios.get(
            `${Configurations.apiEndPoints.baseUrl}api/common/rolesmodulesandfeatures/${userName}`
        )
        return response
    } catch (error) {
        console.error('fetchUserPermissions::', error)
        return null
    }
}

export const fetchHearingLocations = async () => {
    try {
        const response = await axios.get(
            `${Configurations.apiEndPoints.baseUrl}api/common/hearinglocations`
        )
        return response
    } catch (error) {
        console.error('fetchHearingLocations::', error)
        return null
    }
}

export const fetchSMSNumbersByHearingDateAndLocation = async (
    hearingDate,
    hearingLocation
) => {
    try {
        const response = await axios.get(
            `${Configurations.apiEndPoints.baseUrl}/api/notification/phonenumber/hearinglocation/${hearingLocation}/hearingdate/${hearingDate}`
        )
        return response
    } catch (error) {
        console.error('fetchSMSNumbersByHearingDateAndLocation::', error)
        return null
    }
}

export const fetchNotificationTemplatesByType = async (type) => {
    try {
        const response = await axios.get(
            `${Configurations.apiEndPoints.baseUrl}api/notification/templates/type/${type}`
        )
        return response
    } catch (error) {
        console.error('fetchNotificationTemplatesByType::', error)
        return null
    }
}

export const sendSMSNotifications = async (payload) => {
    try {
        const response = await axios.post(
            `${Configurations.apiEndPoints.formulaeEngine}api/notification/sms/send`,
            payload
        )
        return response
    } catch (error) {
        console.error('sendSMSNotifications::', error)
        return null
    }
}
